export const comics = [
  {
    id: '1',
    title: '蜜桃少年',
    author: '星辰工作室',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '连载中',
    description: '高中少年林桃在转学后遇见了一群性格各异的同学，从陌生到熟悉，从碰撞到理解，一段关于青春、友情与懵懂爱恋的故事就此展开。在这个蜜桃般甜蜜的夏天，少年们书写着属于他们的青春篇章。',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20peach%20toned%20illustration%20of%20a%20handsome%20teenage%20boy%20with%20soft%20smile%20under%20cherry%20blossom%20tree%2C%20anime%20style%2C%20soft%20lighting%2C%20gentle%20pastel%20background%20with%20pink%20and%20warm%20peach%20tones%2C%20romantic%20youth%20atmosphere%2C%20clean%20composition%2C%20manga%20cover%20aesthetic&width=800&height=1067&seq=comic-cover-01&orientation=portrait',
    updateTime: '2026-07-06',
    rating: 9.6,
    views: 1280000,
    chapters: [
      { id: 'c1-1', title: '第1话 转学生', number: 1, updateTime: '2026-06-01' },
      { id: 'c1-2', title: '第2话 初遇', number: 2, updateTime: '2026-06-08' },
      { id: 'c1-3', title: '第3话 图书馆的秘密', number: 3, updateTime: '2026-06-15' },
      { id: 'c1-4', title: '第4话 夏日祭典', number: 4, updateTime: '2026-06-22' },
      { id: 'c1-5', title: '第5话 心动的信号', number: 5, updateTime: '2026-06-29' },
      { id: 'c1-6', title: '第6话 大结局', number: 6, updateTime: '2026-07-06' },
    ],
  },
  {
    id: '2',
    title: '星空下的约定',
    author: '月光画室',
    category: '恋爱',
    categorySlug: 'lianai',
    status: '已完结',
    description: '天文社的两个少年在观测星空时相遇，从星座聊到宇宙，再从宇宙聊到彼此的梦想。流星划过夜空的那一刻，他们许下了只属于两个人的约定。',
    coverImage: 'https://readdy.ai/api/search-image?query=Two%20teenage%20boys%20standing%20under%20starry%20night%20sky%2C%20anime%20illustration%20style%2C%20one%20pointing%20at%20stars%2C%20deep%20blue%20night%20sky%20with%20shooting%20stars%2C%20warm%20golden%20moonlight%2C%20romantic%20atmosphere%2C%20clean%20manga%20cover%20aesthetic%2C%20soft%20gradient%20background&width=800&height=1067&seq=comic-cover-02&orientation=portrait',
    updateTime: '2026-07-05',
    rating: 9.4,
    views: 960000,
    chapters: [
      { id: 'c2-1', title: '第1话 天文社的新成员', number: 1, updateTime: '2026-05-01' },
      { id: 'c2-2', title: '第2话 星座的故事', number: 2, updateTime: '2026-05-15' },
      { id: 'c2-3', title: '第3话 流星雨之夜', number: 3, updateTime: '2026-06-01' },
      { id: 'c2-4', title: '第4话 大结局 约定', number: 4, updateTime: '2026-06-30' },
    ],
  },
  {
    id: '3',
    title: '篮球少年日记',
    author: '热血工坊',
    category: '校园',
    categorySlug: 'xiaoyuan',
    status: '连载中',
    description: '转学到新学校的篮球少年，面对强大的校队对手和严苛的训练，凭借对篮球的热爱和不懈的努力，一步步成长为球队核心的热血故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Teenage%20boy%20holding%20basketball%20on%20court%2C%20anime%20illustration%20style%2C%20dynamic%20pose%2C%20warm%20sunset%20lighting%20on%20sports%20court%2C%20orange%20and%20golden%20warm%20tones%2C%20clean%20manga%20cover%20aesthetic%2C%20sports%20atmosphere%2C%20soft%20gradient%20background&width=800&height=1067&seq=comic-cover-03&orientation=portrait',
    updateTime: '2026-07-04',
    rating: 9.3,
    views: 850000,
    chapters: [
      { id: 'c3-1', title: '第1话 新的开始', number: 1, updateTime: '2026-04-01' },
      { id: 'c3-2', title: '第2话 首次对决', number: 2, updateTime: '2026-04-15' },
      { id: 'c3-3', title: '第3话 特训', number: 3, updateTime: '2026-05-01' },
      { id: 'c3-4', title: '第4话 地区大赛', number: 4, updateTime: '2026-05-20' },
    ],
  },
  {
    id: '4',
    title: '魔法学园物语',
    author: '幻境漫画',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: '连载中',
    description: '普通少年意外进入魔法学园，发现自己拥有罕见的双系魔法天赋。在探索魔法世界的过程中，他结识了一群志同道合的伙伴，共同面对黑暗势力的威胁。',
    coverImage: 'https://readdy.ai/api/search-image?query=Teenage%20boy%20casting%20magic%20spell%20with%20glowing%20hands%2C%20anime%20illustration%20style%2C%20magical%20academy%20background%2C%20warm%20golden%20and%20amber%20magic%20glow%2C%20soft%20pastel%20robes%2C%20fantasy%20atmosphere%2C%20clean%20manga%20cover%20aesthetic&width=800&height=1067&seq=comic-cover-04&orientation=portrait',
    updateTime: '2026-07-03',
    rating: 9.5,
    views: 1120000,
    chapters: [
      { id: 'c4-1', title: '第1话 魔法觉醒', number: 1, updateTime: '2026-03-01' },
      { id: 'c4-2', title: '第2话 入学测试', number: 2, updateTime: '2026-03-20' },
      { id: 'c4-3', title: '第3话 双系天赋', number: 3, updateTime: '2026-04-10' },
      { id: 'c4-4', title: '第4话 暗影来袭', number: 4, updateTime: '2026-05-01' },
      { id: 'c4-5', title: '第5话 伙伴集结', number: 5, updateTime: '2026-05-25' },
    ],
  },
  {
    id: '5',
    title: '青春不散场',
    author: '拾光绘社',
    category: '青春',
    categorySlug: 'qingchun',
    status: '已完结',
    description: '高三最后一个学期，五个性格各异的少年面对升学、梦想和分别，在彼此陪伴中度过这段最难忘的时光。青春的列车终将到站，但回忆永不散场。',
    coverImage: 'https://readdy.ai/api/search-image?query=Five%20teenage%20boys%20laughing%20together%20on%20school%20rooftop%2C%20anime%20illustration%20style%2C%20warm%20golden%20sunset%20light%2C%20cherry%20blossom%20petals%20floating%2C%20nostalgic%20youth%20atmosphere%2C%20clean%20manga%20cover%20aesthetic%2C%20soft%20warm%20peach%20and%20orange%20sky&width=800&height=1067&seq=comic-cover-05&orientation=portrait',
    updateTime: '2026-06-28',
    rating: 9.7,
    views: 1560000,
    chapters: [
      { id: 'c5-1', title: '第1话 最后的学期', number: 1, updateTime: '2026-03-15' },
      { id: 'c5-2', title: '第2话 各自的梦想', number: 2, updateTime: '2026-04-01' },
      { id: 'c5-3', title: '第3话 学园祭', number: 3, updateTime: '2026-04-20' },
      { id: 'c5-4', title: '第4话 毕业旅行', number: 4, updateTime: '2026-05-10' },
      { id: 'c5-5', title: '第5话 大结局 不说再见', number: 5, updateTime: '2026-06-28' },
    ],
  },
  {
    id: '6',
    title: '迷途侦探社',
    author: '暗夜绘馆',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: '连载中',
    description: '高中生侦探社团接手一系列离奇案件，在蛛丝马迹中寻找真相。每个案件背后都隐藏着不为人知的秘密，少年侦探们用智慧与勇气揭开层层迷雾。',
    coverImage: 'https://readdy.ai/api/search-image?query=Teenage%20boy%20detective%20holding%20magnifying%20glass%2C%20anime%20illustration%20style%2C%20mysterious%20dark%20library%20background%2C%20warm%20lamplight%20glow%2C%20dramatic%20shadows%2C%20mystery%20atmosphere%2C%20clean%20manga%20cover%20aesthetic%2C%20sepia%20and%20warm%20amber%20tones&width=800&height=1067&seq=comic-cover-06&orientation=portrait',
    updateTime: '2026-07-02',
    rating: 9.2,
    views: 720000,
    chapters: [
      { id: 'c6-1', title: '第1话 侦探社的委托', number: 1, updateTime: '2026-04-01' },
      { id: 'c6-2', title: '第2话 消失的试卷', number: 2, updateTime: '2026-04-18' },
      { id: 'c6-3', title: '第3话 音乐室的幽灵', number: 3, updateTime: '2026-05-05' },
    ],
  },
  {
    id: '7',
    title: '古剑奇缘',
    author: '墨韵阁',
    category: '古装',
    categorySlug: 'guzhuang',
    status: '连载中',
    description: '少年剑客背负家族使命，踏上了寻找传说古剑的旅程。在江湖历练中，他结识了各路豪杰，也卷入了朝堂与江湖的纷争之中。',
    coverImage: 'https://readdy.ai/api/search-image?query=Young%20swordsman%20in%20traditional%20Chinese%20hanfu%20holding%20ancient%20sword%2C%20anime%20illustration%20style%2C%20misty%20mountain%20background%20with%20plum%20blossoms%2C%20warm%20golden%20sunrise%20light%2C%20classical%20Chinese%20martial%20arts%20atmosphere%2C%20clean%20manga%20cover%20aesthetic&width=800&height=1067&seq=comic-cover-07&orientation=portrait',
    updateTime: '2026-07-01',
    rating: 9.4,
    views: 980000,
    chapters: [
      { id: 'c7-1', title: '第1话 少年初入江湖', number: 1, updateTime: '2026-02-15' },
      { id: 'c7-2', title: '第2话 古剑传说', number: 2, updateTime: '2026-03-10' },
      { id: 'c7-3', title: '第3话 酒馆奇遇', number: 3, updateTime: '2026-04-01' },
      { id: 'c7-4', title: '第4话 竹林之战', number: 4, updateTime: '2026-04-25' },
      { id: 'c7-5', title: '第5话 京城风云', number: 5, updateTime: '2026-05-20' },
    ],
  },
  {
    id: '8',
    title: '咖啡店奇妙夜',
    author: '暖阳画坊',
    category: '都市',
    categorySlug: 'dushi',
    status: '已完结',
    description: '城市角落的一家深夜咖啡店，每晚都会迎来形形色色的客人。少年店长用一杯杯温暖的饮品，倾听着每个客人的故事，也治愈着他们疲惫的心灵。',
    coverImage: 'https://readdy.ai/api/search-image?query=Teenage%20boy%20barista%20making%20coffee%20in%20cozy%20cafe%2C%20anime%20illustration%20style%2C%20warm%20interior%20lighting%2C%20steam%20rising%20from%20coffee%20cup%2C%20evening%20atmosphere%2C%20comforting%20warm%20amber%20and%20brown%20tones%2C%20clean%20manga%20cover%20aesthetic&width=800&height=1067&seq=comic-cover-08&orientation=portrait',
    updateTime: '2026-06-20',
    rating: 9.1,
    views: 680000,
    chapters: [
      { id: 'c8-1', title: '第1话 深夜来客', number: 1, updateTime: '2026-04-01' },
      { id: 'c8-2', title: '第2话 失恋的雨季', number: 2, updateTime: '2026-04-20' },
      { id: 'c8-3', title: '第3话 大结局 天亮之前', number: 3, updateTime: '2026-06-20' },
    ],
  },
  {
    id: '9',
    title: '搞笑日常大王',
    author: '欢乐制造机',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: '连载中',
    description: '四个性格截然不同的高中男生，在日常学习和生活中闹出的种种笑话。无厘头的脑洞、爆笑的误会和温馨的朋友情谊，让你笑到停不下来。',
    coverImage: 'https://readdy.ai/api/search-image?query=Four%20teenage%20boys%20making%20funny%20faces%20together%2C%20anime%20illustration%20style%2C%20bright%20colorful%20school%20background%2C%20comedic%20expressions%2C%20lively%20atmosphere%2C%20warm%20sunny%20lighting%2C%20clean%20manga%20cover%20aesthetic%2C%20playful%20vibrant%20colors&width=800&height=1067&seq=comic-cover-09&orientation=portrait',
    updateTime: '2026-07-06',
    rating: 9.0,
    views: 920000,
    chapters: [
      { id: 'c9-1', title: '第1话 自我介绍大作战', number: 1, updateTime: '2026-05-01' },
      { id: 'c9-2', title: '第2话 食堂争夺战', number: 2, updateTime: '2026-05-15' },
      { id: 'c9-3', title: '第3话 考试前夜', number: 3, updateTime: '2026-06-01' },
      { id: 'c9-4', title: '第4话 文化祭的灾难', number: 4, updateTime: '2026-06-20' },
    ],
  },
]

export const hotRecommends = comics.slice(0, 3)

export const latestUpdates = [...comics].sort((a, b) =>
  new Date(b.updateTime).getTime() - new Date(a.updateTime).getTime()
).slice(0, 6)

export const stats = {
  totalComics: 12580,
  totalChapters: 356000,
  dailyVisits: 1280000,
  registeredUsers: 8600000,
}